import { render, staticRenderFns } from "./RegistrationConfirmed.vue?vue&type=template&id=a352bd0c"
import script from "./RegistrationConfirmed.vue?vue&type=script&lang=js"
export * from "./RegistrationConfirmed.vue?vue&type=script&lang=js"
import style0 from "./RegistrationConfirmed.vue?vue&type=style&index=0&id=a352bd0c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports